<template>
  <div class="container-fluid p-0">
    <div class="col-12 mb-2">
      <div class="row align-items-center text-center">
        <!--<div class="card" v-if="hasAccess">-->
        <div class="col-12 text-center">
          <button @click="openNewModal" class="btn iconed btn-secondary"><i
            class="icon-bd-plus"></i><span>جدید</span></button>
        </div>
        <!--</div>-->
      </div>
    </div>


    <div v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>
      <table class="table table-striped">
        <thead>
        <tr>
          <!--<th scope="col" class="text-center">عملیات</th>-->
          <!--<th scope="col" class="text-center">ردیف</th>-->
          <th scope="col" class="text-center">نام چک لیست</th>
          <th scope="col" class="text-center">نوع چک لیست</th>
          <th scope="col" class="text-center">شرح مختصر</th>
          <th scope="col" class="text-center">ابزارها</th>
          <th scope="col" class="text-center">کالاهای مصرفی</th>
          <th scope="col" class="text-center">دانلود ضمیمه</th>
          <th scope="col" class="text-center">عملیات</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in checkListsPage">

          <!--<th scope="row" class="text-center">{{item.id}}</th>-->
          <td class="text-center  text-nowrap">{{item.name}}</td>
          <td class="text-center">{{item.enPMListTypeTitle}}</td>
          <td class="text-center">{{item.shortDescription}}</td>
          <td class="text-center">{{item.tools}}</td>
          <td class="text-center">{{item.needMaterial}}</td>
          <td class="text-center">
            <a v-if="item.attachFileId!=='' && item.attachFileId!=null"
               :href="validateDownloadImageUrl(item.attachFile.address)"
               target="_blank"
               download
               style="color: inherit !important;"
            ><i class="fa fa-download px-3 clickable"
                style="font-size: larger"
                title="دانلود"></i></a></td>
          <td class="text-center text-nowrap">
            <i class="fa fa-print px-3 clickable"
               style="font-size: larger"
               @click="onPrintClicked(item)"
               title="پرینت"></i>
            <i class="fa fa-pencil-square-o px-3 clickable"
               style="font-size: larger"
               @click="onEditClicked(item)"
               title="ویرایش"></i>
            <i class="fa fa-trash-o px-3 clickable"
               style="font-size: larger"
               @click="onDeleteClicked(item.id)"
               title="حذف"></i>
          </td>

        </tr>
        </tbody>
      </table>
      <div class="col-12">
        <b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"
                      @input="nextPage(pageIndex)"/>
      </div>

    </div>
    <!------------ MODALS -------------------------------------------------------------------->
    <b-modal
      id="createChekList"
      ref="createChekList"
      size="lg"
      title="چک لیس جدید"
      ok-title="ذخیره"
      cancel-title="بستن"
      @ok="saveCheckList"
    >

        <div class="row mb-2">
          <div class="col-6">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>نام چک لیست</span>
                </div>
              </div>
              <input type="text" class="form-control" v-model="checkListModel.name">

            </div>
          </div>
          <div class="col-6">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>نوع چک لیست</span>
                </div>

                <!--:selectedVal="checkListModel.enPMListTypeTitle"-->
                <vs-select
                  ref="selectedListType"
                  :isHeader="true"
                  :data="enPMListTypes"
                  :header="{label:'title'}"
                  :mode="'edit'"
                  @dataChanged="listTypeSelect"
                ></vs-select>
                <!--style="max-width:70%;"-->
                <!--v-if="!sellOnly && mode!=='view'"-->
              </div>
            </div>
          </div>
          <div class="col-12 mt-2" v-if="checkListModel.enPMListType === 3">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>واحد اندازه گیری</span>
                </div>
              </div>
              <input type="text" class="form-control" v-model="checkListModel.unit">

            </div>
          </div>

        </div>

        <div class="row mb-2">
          <div class="col-12">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>شرح مختصر</span>
                </div>
              </div>
              <input type="text" class="form-control" v-model="checkListModel.shortDescription">

            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="input-group col-sm-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>توضیحات</span>
              </div>
            </div>
            <textarea   class="form-control" v-model="checkListModel.description"></textarea>

          </div>
        </div>
        <div class="row mb-2">
          <div class="input-group col-sm-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ابزارهای مورد نیاز</span>
              </div>
            </div>
            <textarea  class="form-control" v-model="checkListModel.tools"></textarea>

          </div>
        </div>
        <div class="row mb-2">
          <div class="input-group col-sm-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کالاهای مصرفی مورد نیاز</span>
              </div>
            </div>
            <textarea  class="form-control" v-model="checkListModel.needMaterial"></textarea>

          </div>
        </div>
        <div class="row mb-2">
          <div class="col-lg-12 text-center" v-if="newFileClicked">
            <span>{{attachFile.name}}</span>
          </div>
          <div class="col-lg-12 text-center">

            <input type="file" id="fileUpload6" class="d-none"
                   @change="oncatalog1Change($event)">
            <label for="fileUpload6" class="btn btn-info btn-round mb-3 clickable">بارگذاری فایل ضمیمه</label>
          </div>
        </div>
    </b-modal>
    <!----- PRINT --------------------------------------------------------------------------->

    <div id="printMe" class="d-none">
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام چک لیست</span>
              </div>
            </div>
            <span   class="form-control"  >{{checkListModel.name}}</span>

          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نوع چک لیست</span>
              </div>

               <span  class="form-control">{{checkListModel.enPMListTypeTitle}}</span>
            </div>
          </div>
        </div>
      <div class="col-12 mt-2" v-if="checkListModel.enPMListType === 3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>واحد اندازه گیری</span>
              </div>

               <span  class="form-control">{{checkListModel.unit}}</span>
            </div>
          </div>
        </div>


      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شرح مختصر</span>
              </div>
            </div>
            <span  class="form-control" >{{checkListModel.shortDescription}}</span>

          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <textarea  class="form-control" >{{checkListModel.description}}</textarea>

        </div>
      </div>
      <div class="row mb-2">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>ابزارهای مورد نیاز</span>
            </div>
          </div>
          <textarea   class="form-control" >{{checkListModel.tools}}</textarea>

        </div>
      </div>
      <div class="row mb-2">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کالاهای مصرفی مورد نیاز</span>
            </div>
          </div>
          <textarea   class="form-control"  >{{checkListModel.needMaterial}}</textarea>

        </div>
      </div>

    </div>
  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import Moment from "moment-jalali";
  import Vue from "vue";
  import Products from "../Products.vue";
  import * as $ from 'jquery';
  import checkAccess from "../../checkAccess";
  import CreateWork from "../CreateWork";
  import Utils from "../../_framework/utils/Utils";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Constants from "../../Constants";

  export default {
    name: "checkLists",
    props: {},
    components: {
      CreateWork,
      VsSelect,
      Products,
      datePicker: DatePicker,
    },
    data: function () {
      return {

        isLoading: false,
        isEditing: false,
        newFileClicked: false,
        hasAccess: true,
        printItem: {},
        access: {},
        allWorks: [],
        checkLists: [],
        checkListsPage: [],
        rows: 0,
        pageSize: 12,
        pageIndex: 1,
        enPMListTypes: [],
        checkListModel: {
          name: "",
          unit: "",
          shortDescription: "",
          description: "",
          tools: "",
          needMaterial: "",
          enPMListType: 0,
          enPMListTypeTitle: "",
          attachFile: null,

        },
        attachFile: {
          name: "",
          address: "",
          newaddress: "",
          extention: "",
        }


      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);


      this.getType();
      // this.getdamageType();
      // this.getUsers();
    },
    methods: {
      getList() {
        new BaseService('PManagment', '/GetPMCheckList').getList().then((response) => {
          this.checkLists = response.data;
          for (let i of this.checkLists) {
            for (let e of this.enPMListTypes) {
              if (e.value === i.enPMListType) {
                i.enPMListTypeTitle = e.title;
              }
            }
          }
          this.rows = this.checkLists.length;
          // return Object.keys(counts).map(key => ({color: key, count: counts[key]}));

          // this.worksResultPagination = this.allWorks;
          this.nextPage(this.pageIndex);
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      getType() {
        new BaseService('PManagment', '/GetEnPMListType').getList().then((response) => {
          this.enPMListTypes = response.data;
          this.getList();
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      nextPage(index) {
        const nextIndex = (index - 1) * this.pageSize;
        this.checkListsPage = this.checkLists.slice(nextIndex, nextIndex + this.pageSize);
      },
      listTypeSelect(prop, data) {
        console.log("ddd", data)
        if (data) {
          this.checkListModel.enPMListTypeTitle = data.title;
          this.checkListModel.enPMListType = data.value;
          console.log("eee", this.checkListModel.enPMListType);
        }
      },
      saveCheckList() {
        if (this.checkListModel.name === "") {
          Utils.handleErrorWithNotification("نام چک لیست را وارد کنید", this.$noty);

        } else if (this.checkListModel.shortDescription === "") {
          Utils.handleErrorWithNotification("توضیحات مختصر چک لیست را وارد کنید", this.$noty);

        } else if (this.checkListModel.enPMListType === 0) {
          Utils.handleErrorWithNotification("نوع چک لیست را وارد کنید", this.$noty);

        } else if (this.checkListModel.enPMListType === 3 &&this.checkListModel.unit ==="" ) {
          Utils.handleErrorWithNotification("واحد اندازه گیری را وارد کنید", this.$noty);

        } else {
          console.log(this.checkListModel);
          if (this.isEditing) {
            new BaseService('PManagment', '/UpdatePMCheckList').update(this.checkListModel).then((response) => {
              this.nullModel();
              this.getList();
              this.$refs['createChekList'].hide();
              this.$noty.success("با موفقیت ثبت شد");
            }).catch((error) => {
              console.log(error)
              this.$noty.error("متاسفانه خطایی رخ داده است", error);
            });
          } else {
            new BaseService('PManagment', '/CreatePMCheckList').create(this.checkListModel).then((response) => {
              this.nullModel();
              this.getList();
              this.$refs['createChekList'].hide();
              this.$noty.success("با موفقیت ثبت شد");
            }).catch((error) => {
              console.log(error)
              this.$noty.error("متاسفانه خطایی رخ داده است", error);
            });
          }
        }
      },
      validateDownloadImageUrl(img) {
        if (img !== undefined) {
          return Constants.DOWNLOAD_BASE_URL + img;
        }
      },
      oncatalog1Change(e) {
        let files = e.target.files;
        let app = this;
        if (files && files[0]) {
          this.newFileClicked = true;
          for (let item of files) {
            let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
            // if (extension === "jpg" || extension === "JPG" ||
            //     extension === "png" || extension === "PNG" ||
            //     extension === "JPEG" || extension === "jpeg") {
            let reader = new FileReader();
            reader.onload = function (e) {
              // $("#bannerImg").attr("src", e.target.result);
              let a = e.target.result;

              app.attachFile.address = a.substring(a.indexOf(',') + 1, a.length);
              app.attachFile.newaddress = e.target.result;
              app.attachFile.name = item.name;
              app.attachFile.extention = extension;
              app.checkListModel.attachFile = app.attachFile;
            };
            reader.readAsDataURL(item);
            // } else {
            //     alert("لطفا فایل عکس بارگذاری فرمائید");
            // }
          }
        }
      },
      openNewModal() {
        this.nullModel();

        this.$refs['createChekList'].show();
      },
      nullModel() {
        this.newFileClicked = false;
        this.isEditing = false;
        this.checkListModel.name = "";
        this.checkListModel.unit = "";
        this.checkListModel.shortDescription = "";
        this.checkListModel.description = "";
        this.checkListModel.tools = "";
        this.checkListModel.needMaterial = "";
        this.checkListModel.enPMListType = 0;
        this.checkListModel.attachFile = null;

        this.attachFile.name = "";
        this.attachFile.address = "";
        this.attachFile.newaddress = "";
        this.attachFile.extention = "";
      },
      onPrintClicked(item) {
        this.checkListModel.id = item.id;
        this.checkListModel.name = item.name;
        this.checkListModel.unit = item.unit;
        this.checkListModel.shortDescription = item.shortDescription;
        this.checkListModel.description = item.description;
        this.checkListModel.tools = item.tools;
        this.checkListModel.needMaterial = item.needMaterial;
        this.checkListModel.enPMListType = item.enPMListType;
        this.checkListModel.enPMListTypeTitle = item.enPMListTypeTitle;
        setTimeout(() => {
        this.$htmlToPaper('printMe');
        }, 200);
      },
      onEditClicked(item) {
        this.isEditing = true;
        this.checkListModel.id = item.id;
        this.checkListModel.name = item.name;
        this.checkListModel.shortDescription = item.shortDescription;
        this.checkListModel.description = item.description;
        this.checkListModel.tools = item.tools;
        this.checkListModel.needMaterial = item.needMaterial;
        this.checkListModel.enPMListType = item.enPMListType;
        this.$refs['createChekList'].show();
      },
      onDeleteClicked(id) {
        if (confirm("آیا از حذف این چک لیست مطمئن هستید")) {
          new BaseService('PManagment/DeletePMCheckList').delete(id).then((response) => {
            this.nullModel();
            this.getList();
            this.$refs['createChekList'].hide();
          }).catch((error) => {
            console.log(error)
            this.$noty.error("متاسفانه خطایی رخ داده است", error);
          });
        }
      },
    },

  };

</script>

<style scoped>
  .table th, .table td {
    padding: 0.5rem !important;
  }
</style>
